import Footer from "../Common/Footer";
import Header from "../Common/Header";

function NewsandBlog() {
  return (
    <>
    <Header/>
  {/* Start Blog Area */}
  <div className="blog-page-area pt-100 pb-100 bgcolor">
    <div className="container">
    <div className="section-title">
        <h2>News and Blogs</h2>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="single-blog-card blog-card-three">
                <div className="blog-img">
                  <a href="blog-details.html">
                    <img
                      src="assets/images/blog/blog-three-img-2.webp"
                      alt="blog"
                    />
                  </a>
                </div>
                <div className="date">
                  <span>19 November 2024</span>
                </div>
                <div className="single-blog-content">
                
                  <h3>
                    <a href="blog-details.html">
                      Where And How To Watch Live Stream Today
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-blog-card blog-card-three">
                <div className="blog-img">
                  <a href="blog-details.html">
                    <img
                      src="assets/images/blog/blog-three-img-3.webp"
                      alt="blog"
                    />
                  </a>
                </div>
              
                <div className="single-blog-content">
                
                  <h3>
                    <a href="blog-details.html">
                      2024 Insurance Trends And Possible Challenge
                    </a>
                  </h3>
                </div>
              </div>
            </div>
         
       
            <div className="col-lg-4 col-md-4">
              <div className="single-blog-card blog-card-three">
                <div className="blog-img">
                  <a href="blog-details.html">
                    <img
                      src="assets/images/blog/blog-page-img-3.webp"
                      alt="blog"
                    />
                  </a>
                </div>
              
                <div className="single-blog-content">
                
                  <h3>
                    <a href="blog-details.html">
                      Reasons To Explan Fast Business In The Builder
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-blog-card blog-card-three">
                <div className="blog-img">
                  <a href="blog-details.html">
                    <img
                      src="assets/images/blog/blog-three-img-3.webp"
                      alt="blog"
                    />
                  </a>
                </div>
              
                <div className="single-blog-content">
                
                  <h3>
                    <a href="blog-details.html">
                      2024 Insurance Trends And Possible Challenge
                    </a>
                  </h3>
                </div>
              </div>
            </div>
           
            <div className="col-lg-4 col-md-4">
              <div className="single-blog-card blog-card-three">
                <div className="blog-img">
                  <a href="blog-details.html">
                    <img
                      src="assets/images/blog/blog-page-img-3.webp"
                      alt="blog"
                    />
                  </a>
                </div>
              
                <div className="single-blog-content">
                
                  <h3>
                    <a href="blog-details.html">
                      Reasons To Explan Fast Business In The Builder
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-blog-card blog-card-three">
                <div className="blog-img">
                  <a href="blog-details.html">
                    <img
                      src="assets/images/blog/blog-three-img-3.webp"
                      alt="blog"
                    />
                  </a>
                </div>
              
                <div className="single-blog-content">
                
                  <h3>
                    <a href="blog-details.html">
                      2024 Insurance Trends And Possible Challenge
                    </a>
                  </h3>
                </div>
              </div>
            </div>
           
          </div>
        
        </div>
    
      </div>
    </div>
  </div>
  {/* End Blog Area */}
  <Footer/>
</>

  );
}

export default NewsandBlog;
